import { IResDirectNumber } from './../../api/interfaces';
import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'stay-mgmt-res-direct',
    templateUrl: './res-direct.component.html'
})
export class ResDirectComponent implements OnInit {

    @Input() messages;
    @Input() resDirect: IResDirectNumber;
    trslt_reservations: string;

    constructor() { }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/res-direct/res-direct.component.ts